namespace RioERP.Enquiry {
    export interface EnquiryRow {
        Id?: number;
        EnquiryName?: string;
        CustomerId?: number;
        EnquiryDate?: string;
        EStatus?: Web.Enums.EnquiryStatus;
        EnquiryType?: Web.Enums.EnquiryType;
        EmailId1?: string;
        EmailId2?: string;
        Mobile1?: string;
        Mobile2?: string;
        Address1?: string;
        Address2?: string;
        City?: string;
        StateId?: number;
        Pincode?: number;
        SubjectId?: number;
        CategoryId?: number;
        NopEnquiryId?: number;
        Country?: string;
        FollowupDate?: string;
        FollowUpTime?: string;
        IsActive?: boolean;
        HandledBy?: number;
        EEnquiryMode?: Web.Enums.EnquiryMode;
        Note?: string;
        RowIds?: string;
        OrderIds?: string;
        UserUsername?: string;
        StateName?: string;
        CategoryName?: string;
        SubjectName?: string;
        CustomerName?: string;
        CustomerEmailId1?: string;
        CustomerEmailId2?: string;
        CustomerMobile1?: string;
        CustomerMobile2?: string;
        CustomerIsActive?: boolean;
        CustomerInsertUserId?: number;
        CustomerInsertDate?: string;
        CustomerUpdateUserId?: number;
        CustomerUpdateDate?: string;
        CustomerECustomerType?: number;
        CustomerGstin?: string;
        CustomerCouponCode?: string;
        EnquiryProduct?: string;
        EnquiryProducts?: number[];
        EnquiryFollowUp?: EnquiryFollowupRow[];
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
    }

    export namespace EnquiryRow {
        export const idProperty = 'Id';
        export const nameProperty = 'EnquiryName';
        export const localTextPrefix = 'Enquiry.Enquiry';
        export const lookupKey = 'Enquiry.Enquiry';

        export function getLookup(): Q.Lookup<EnquiryRow> {
            return Q.getLookup<EnquiryRow>('Enquiry.Enquiry');
        }
        export const deletePermission = 'Enquiry:EnquiryManagement:Modify';
        export const insertPermission = 'Enquiry:EnquiryManagement:Modify';
        export const readPermission = 'Enquiry:EnquiryManagement:View';
        export const updatePermission = 'Enquiry:EnquiryManagement:Modify';

        export declare const enum Fields {
            Id = "Id",
            EnquiryName = "EnquiryName",
            CustomerId = "CustomerId",
            EnquiryDate = "EnquiryDate",
            EStatus = "EStatus",
            EnquiryType = "EnquiryType",
            EmailId1 = "EmailId1",
            EmailId2 = "EmailId2",
            Mobile1 = "Mobile1",
            Mobile2 = "Mobile2",
            Address1 = "Address1",
            Address2 = "Address2",
            City = "City",
            StateId = "StateId",
            Pincode = "Pincode",
            SubjectId = "SubjectId",
            CategoryId = "CategoryId",
            NopEnquiryId = "NopEnquiryId",
            Country = "Country",
            FollowupDate = "FollowupDate",
            FollowUpTime = "FollowUpTime",
            IsActive = "IsActive",
            HandledBy = "HandledBy",
            EEnquiryMode = "EEnquiryMode",
            Note = "Note",
            RowIds = "RowIds",
            OrderIds = "OrderIds",
            UserUsername = "UserUsername",
            StateName = "StateName",
            CategoryName = "CategoryName",
            SubjectName = "SubjectName",
            CustomerName = "CustomerName",
            CustomerEmailId1 = "CustomerEmailId1",
            CustomerEmailId2 = "CustomerEmailId2",
            CustomerMobile1 = "CustomerMobile1",
            CustomerMobile2 = "CustomerMobile2",
            CustomerIsActive = "CustomerIsActive",
            CustomerInsertUserId = "CustomerInsertUserId",
            CustomerInsertDate = "CustomerInsertDate",
            CustomerUpdateUserId = "CustomerUpdateUserId",
            CustomerUpdateDate = "CustomerUpdateDate",
            CustomerECustomerType = "CustomerECustomerType",
            CustomerGstin = "CustomerGstin",
            CustomerCouponCode = "CustomerCouponCode",
            EnquiryProduct = "EnquiryProduct",
            EnquiryProducts = "EnquiryProducts",
            EnquiryFollowUp = "EnquiryFollowUp",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate"
        }
    }
}
